import React from 'react';
import i18n from 'i18next';

class DRTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  backgroundColorSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  displayNone = {
    display: 'none',
  };

  hideInactiveYears(num) {
    const { isMobile, yearSelected } = this.props;

    if (this.props.type === 'modal') {
      if (isMobile) {
        if (num !== yearSelected) {
          return this.displayNone;
        }
      }
    }

    return null;
  }

  setYearSelected(year) {
    this.props.sendYearSelectedToParent(year);
  }

  get electiveClassString() {
    return i18n.t('Elective', { context: 'Academic Subjects' });
  }

  getClassTitle(list, academicAreaId) {
    const individualClass = list.filter((item) => {
      return item.academic_area_id === academicAreaId;
    });

    if (individualClass[0] !== undefined) {
      if (individualClass[1] !== undefined) {
        return `${individualClass[0].titleEn}/ ${individualClass[1].titleEn}`;
      }

      return individualClass[0].titleEn;
    }

    return this.electiveClassString;
  }

  displayPDFColumn(subjectTitle) {
    return (
      <th
        scope="row"
        style={{ color: 'black' }}
        className="right-align border-right"
      >
        {subjectTitle}
      </th>
    );
  }

  generateYearHeader = (yearNum) => {
    return (
      <th
        onClick={() => {
          this.setYearSelected(yearNum);
        }}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) this.setYearSelected(yearNum);
        }}
        className="degree-requirements-content-header"
      >
        {`Year ${yearNum}`}
        <div
          className="secondary-underline"
          style={this.backgroundColorSecondary}
        />
      </th>
    );
  };

  generateTableData(yearNum, classTitle) {
    const borderRight =
      yearNum < 4 && !(this.props.isMobile && this.props.type === 'modal');
    const classNamesForTD = [];

    if (this.props.type === 'pdf') classNamesForTD.push('pdf-td');
    if (borderRight) classNamesForTD.push('border-right');

    return (
      <td
        id={
          this.props.type === 'pdf' || this.props.type.includes('complete-plan')
            ? 'pdf-td'
            : null
        }
        style={this.hideInactiveYears(yearNum)}
        className={classNamesForTD.join(' ')}
      >
        {classTitle}
      </td>
    );
  }

  render() {
    const { year1, year2, year3, year4, isMobile, type } = this.props;

    return (
      <table className="degree-requirements degree-requirements-table">
        <thead
          style={
            isMobile && this.props.type === 'modal' ? this.displayNone : null
          }
        >
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan') ? (
              <th className="degree-requirements-content-header">
                Subject
                <div
                  className="secondary-underline"
                  style={this.backgroundColorSecondary}
                />
              </th>
            ) : null}
            {this.generateYearHeader(1)}
            {this.generateYearHeader(2)}
            {this.generateYearHeader(3)}
            {this.generateYearHeader(4)}
          </tr>
        </thead>
        <tbody>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('English')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 1))}
            {this.generateTableData(2, this.getClassTitle(year2, 1))}
            {this.generateTableData(3, this.getClassTitle(year3, 1))}
            {this.generateTableData(4, this.getClassTitle(year4, 1))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Math')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 2))}
            {this.generateTableData(2, this.getClassTitle(year2, 2))}
            {this.generateTableData(3, this.getClassTitle(year3, 2))}
            {this.generateTableData(4, this.getClassTitle(year4, 2))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Laboratory Science')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 3))}
            {this.generateTableData(2, this.getClassTitle(year2, 3))}
            {this.generateTableData(3, this.getClassTitle(year3, 3))}
            {this.generateTableData(4, this.getClassTitle(year4, 3))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Social Science')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 4))}
            {this.generateTableData(2, this.getClassTitle(year2, 4))}
            {this.generateTableData(3, this.getClassTitle(year3, 4))}
            {this.generateTableData(4, this.getClassTitle(year4, 4))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Foreign Language')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 6))}
            {this.generateTableData(2, this.getClassTitle(year2, 6))}
            {this.generateTableData(3, this.getClassTitle(year3, 6))}
            {this.generateTableData(4, this.getClassTitle(year4, 6))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Fine Arts/Career & Technical Education')
              : null}
            {this.generateTableData(1, this.getClassTitle(year1, 5))}
            {this.generateTableData(2, this.getClassTitle(year2, 5))}
            {this.generateTableData(3, this.getClassTitle(year3, 5))}
            {this.generateTableData(4, this.getClassTitle(year4, 5))}
          </tr>
          <tr>
            {type === 'pdf' || this.props.type.includes('complete-plan')
              ? this.displayPDFColumn('Electives')
              : null}
            {this.generateTableData(1, this.electiveClassString)}
            {this.generateTableData(2, this.electiveClassString)}
            {this.generateTableData(3, this.electiveClassString)}
            {this.generateTableData(4, this.electiveClassString)}
          </tr>
        </tbody>
      </table>
    );
  }
}

export default DRTable;
